/**
 * Group by function names
 *
 * @readonly
 * @enum {string}
 */
const GROUP_BY_FUNCTIONS = {
    SUM: 'sum',
    AVG: 'avg',
    MIN: 'min',
    MAX: 'max',
    FIRST: 'first',
    LAST: 'last',
    COUNT: 'count',
    STD: 'std'
};

export default GROUP_BY_FUNCTIONS;
